<!--header class="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 mb-3 bg-white border-bottom shadow-sm"-->
  <!--p class="h5 my-0 me-md-auto fw-normal">Parohia Pantelimon II</p-->
  <nav class="navbar navbar-expand-md navbar-dark bg-dark2 ">
    <div class="container-fluid">
      <a class="navbar-brand text-break-spaces" id="siteTitle" href="#">Parohia Pantelimon II</a>
      <button id="navbarButton" class="navbar-toggler ms-auto" type="button" (click)="toggleIsCollaped()" [attr.aria-expanded]="!isCollapsed" aria-controls="navbarsExampleDefault" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <!--div class="mx-auto"-->
      <div class="collapse navbar-collapse" id="navbarsExampleDefault" [ngbCollapse]="isCollapsed">
        <ul class="navbar-nav align-items-center">
          <li class="nav-item dropdown text-center"><!--active-->
            <a class="nav-link" aria-current="page" href="#" (click)="changeMenu('primapagina')">Prima pagină</a>
          </li>        
          <li class="nav-item dropdown text-center">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Parohie
            </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" href="#" (click)="collapseMenu()">Biserica parohiei</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="#" (click)="changeMenu('preoti')">Slujitori</a>
            </div>
          </li>
          <li class="nav-item dropdown text-center">
            <a class="nav-link" href="#"  (click)="changeMenu('istoric')">Istorie</a>
          </li>
          <li class="nav-item dropdown text-center">
            <a class="nav-link" href="#" (click)="collapseMenu()">Programul slujbelor</a>
          </li>
          <li class="nav-item dropdown text-center">
            <a class="nav-link" href="#" (click)="changeMenu('galeriefoto')">Galerie foto</a>
          </li>
          <li class="nav-item dropdown text-center">
            <a class="nav-link" href="#" (click)="changeMenu('2lasuta')">2% pentru Biserică</a>
          </li>
          <li class="nav-item dropdown text-center">
            <a class="nav-link" href="#" (click)="collapseMenu()">Contact</a>
          </li>
          <!--li class="nav-item">
            <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">Disabled</a>
          </li-->
        </ul>
        <!--form class="d-flex">
          <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
          <button class="btn btn-outline-success" type="submit">Search</button>
        </form-->
      </div>
      <!--/div-->
    </div>
  </nav>
<!--/header-->

<div class="container-fluid">
  <div class="row mt-3 justify-content-around align-items-start">
    <div class="col-4 col-sm-3 col-md-2 col-lg-1 p-0">
      <img src="assets/Icoane/Icoana_hram_stanga_2.jpg" class="img-thumbnail" alt="...">
    </div>
    <div class="col d-none d-md-flex p-0">      
      <img src="assets/Icoane/Icoana_partea_de_sus.jpg" class="img-thumbnail" alt="...">
    </div>
    <div class="col-4 col-sm-3 col-md-2 col-lg-1 p-0">
      <img src="assets/Icoane/Icoana_hram_dreapta_2.jpg" class="img-thumbnail" alt="...">
    </div>
  </div>
  <!--div class="row">
    <div class="col">
    </div>
    <div class="col-8 col-md-10 p-0">
    </div>
    <div class="col">
    </div>
  </div-->
</div>
<div *ngIf="chapter=='primapagina'">
  <div class="container-fluid">
    <div class="row justify-content-center align-items-center mt-3">      
      <div class="text-center">
        <!--h2 class="fw-normal">Site în lucru...</h2>
        <br-->
        <!--h3 class="fw-light">Galerie</h3-->
      </div>
      <!--div class="col-3 col-sm-2 p-0 text-center h3"></div-->
      <div class="col-12 p-0 text-center">    
        <span class="h3 pointer" (click)="galleryLeft()">&#8592;</span> 
        <img src="assets/Fotografii/viata_comunitatii/{{currentPhoto}}.jpg" class="img-thumbnail" alt="Foto credit: Ziarul Lumina" title="Foto credit: Ziarul Lumina">
        <span class="h3 pointer" (click)="galleryRight()">&#8594;</span>
      </div>
      <!--div class="col-3 col-sm-2 p-0 text-center h3"></div-->
    </div>
    <div class="d-none d-md-flex row justify-content-md-center mt-3">
      <div class="col" *ngFor="let no of [1,2,3,4,5,6,7,8,9,10]">      
        <img src="assets/Fotografii/viata_comunitatii/{{no}}.jpg" class="img-thumbnail" alt="Foto credit: Ziarul Lumina" title="Foto credit: Ziarul Lumina">
      </div>
    </div>
  </div>
  <div class="container-fluid mt-5">
    <div class="row mt-3 justify-content-around">
      <div class="col-12 col-md-9 p-2">        
        <!--h3 class="fw-light text-center">Noutăți</h3-->   
        
        <div class="card mb-2 mt-4">
          <div class="card-body">
            <div class="row justify-content-center">   
              <img src="assets/IMG/antet_anaf_2025.png" class="card-img-top">
              <div class="align-items-center text-center">
                <hr/> 
                <h3>Donează pentru construirea bisericii</h3>
                <br>
                <a href="./assets/Formular/Formular_anaf_pt_anul_2025.pdf" target="_blank" class="btn btn-primary">Descarcă formularul!</a>
              </div> 
            </div>
          </div>
        </div>  

        <div class="card mb-2 mt-4">
          <img src="assets/Fotografii/ito_bucuresti_2026.png" class="card-img-top" alt="Foto credit: ITO România"> 
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">
              Întâlnirea Tinerilor Ortodocși București 2026</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">Întâlnirea Tinerilor Ortodocși București 2026</p>
            <a href='https://www.facebook.com/itoromania' target="_blank" class="btn btn-primary">Mergi la pagină!</a>
          </div>
        </div>  

        <div class="card mb-2 mt-4">
          <img src="assets/Fotografii/jurnal_trinitas_concurs_tematic.png" class="card-img-top" alt="Foto credit: Jurnal Trinitas"> 
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">
              Concurs tematic în cadrul „Centrului de activități cu tineretul Sfântul Ilie Tesviteanul”</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">În cadrul centrului de activități cu tineretul „Sfântul Ilie Tesviteanul” a avut loc etapa concursului tematic</p>
            <a href='https://www.youtube.com/watch?v=Zyhh9MKltNk' target="_blank" class="btn btn-primary">Vizionează articolul!</a>
          </div>
        </div>  

        <div class="card mb-2 mt-4">
          <img src="assets/Fotografii/lansarea_proiectului_centrul_activitati_tineret.png" class="card-img-top" alt="Foto credit: Jurnal Trinitas"> 
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">S-a lansat proiectul Centrului de activități cu tineretul „Sfântul Ilie Tesviteanul”</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">S-a lansat proiectul Centrului de activități cu tineretul „Sfântul Ilie Tesviteanul”</p>
            <a href='https://www.trinitas.tv/lansarea-proiectului-national-centrul-de-activitati-cu-tineretul-sfantul-ilie-tesviteanul/' target="_blank" class="btn btn-primary">Vizionează articolul!</a>
          </div>
        </div>  
        
        <div class="card my-2">
          
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">Stadiul lucrărilor la biserica Parohiei</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">Stadiul lucrărilor la biserica Parohiei</p>
            <video #videoStadiuLucrari controls autoplay>
              <source src="assets/Video/stadiul_lucrarilor_biserica_parohiei_nov_2025.mp4" type="video/mp4">
              Browser-ul Dumneavoastră nu acceptă tag-ul video!
            </video>
          </div>  

          <!--img src="assets/Fotografii/constructie/{{proiectPhotos[currentProiectPhotoIndex]}}.jpg" class="card-img-top" alt="Parohia Pantelimon II"-->
        </div>

        <div class="card mb-2 mt-4">
          <img src="assets/Fotografii/noua_parohie_haderslev.png" class="card-img-top" alt="Foto credit: Jurnal Trinitas"> 
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">Prima liturghie arhierească în Parohia Haderslev</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">Prima liturghie arhierească în Parohia Haderslev</p>
            <a href='https://www.facebook.com/reel/1348763409644849/' target="_blank" class="btn btn-primary">Vizionează articolul!</a>
          </div>
        </div>  
        <div class="card mb-2 mt-4">
          <img src="assets/Fotografii/eveniment_traditii_si_credinta_youtube.png" class="card-img-top" alt="Foto credit: Jurnal Trinitas"> 
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">Evenimentul ”Tradiții si Credință”</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">Evenimentul ”Tradiții si Credință”</p>
            <a href='https://www.youtube.com/watch?v=T2YawuziCkU&ab_channel=TRINITASTV' target="_blank" class="btn btn-primary">Vizionează articolul!</a>
          </div>
        </div>       
        <div class="card mb-2 mt-4">
          <img src="assets/Fotografii/traditii_si_credinta.jpg" class="card-img-top" alt="Foto credit: Basilica">
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">Evenimentul ”Tradiții si Credință” - Articol Jurnalul de Ilfov</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">Evenimentul ”Tradiții si Credință” </p>
            <a href='https://jurnaluldeilfov.ro/sambata-luminata-i-a-reunit-din-nou-pe-locuitorii-orasului-pantelimon-caritate-traditii-si-credinta-intr-o-a-doua-editie-de-succes/' target="_blank" class="btn btn-primary">Citește mai multe!</a>
          </div>
        </div>
        <div class="card mb-2 mt-4">
          <img src="assets/Fotografii/teza-de-doctorat-despre-seminarul-central-din-bucuresti-298353.jpg" class="card-img-top" alt="Foto credit: Ziarul Luumina">
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">„Teză de doctorat despre Seminarul Central din Bucureşti” - Articol Ziarul Lumina</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">„Teză de doctorat despre Seminarul Central din Bucureşti”</p>
            <a href='https://ziarullumina.ro/actualitate-religioasa/stiri/teza-de-doctorat-despre-seminarul-central-din-bucuresti-190076.html?fbclid=IwZXh0bgNhZW0CMTEAAR2hYZ6P8cGxcAawWMufw5Y350KmRGBAktsTT1UrDte6xAsriuTKeWDKCRs_aem_AeZsnnkthAgvBGv2Bca3pQEbmeEsbR-rYZZejSC076pDiLyfpqO3N2CIMV8va1CWAABbmtwdOsy1rqiimMbTTux5' target="_blank" class="btn btn-primary">Citește mai multe!</a>
          </div>
        </div>
        <div class="card my-2">
          <img src="assets/Fotografii/basilica_sfintire_paraclis.png" class="card-img-top" alt="Foto credit: Ziarul Lumina">
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">O nouă biserică se construiește în orașul Pantelimon. PS Veniamin a sfințit paraclisul dat în funcțiune la demisol</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">O nouă biserică se construiește în orașul Pantelimon. PS Veniamin a sfințit paraclisul dat în funcțiune la demisol</p>
            <a href='https://basilica.ro/o-noua-biserica-se-construieste-in-orasul-pantelimon-ps-veniamin-a-sfintit-paraclisul-dat-in-functiune-la-demisol/' target="_blank" class="btn btn-primary">Citește mai multe!</a>
          </div>
        </div>
        
        <div class="card my-2">
          <img src="assets/Fotografii/lumina_sfintire_paraclis.png" class="card-img-top" alt="Foto credit: Ziarul Lumina">
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">Un nou lăcaș de rugăciune în orașul Pantelimon din județul Ilfov</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">Un nou lăcaș de rugăciune în orașul Pantelimon din județul Ilfov</p>
            <a href='https://ziarullumina.ro/actualitate-religioasa/stiri/un-nou-lacas-de-rugaciune-in-orasul-pantelimon-din-judetul-ilfov-185111.html?fbclid=IwAR0ty2HTRwbw3XUL_Ztqb_Ky8rsP2K2NMnrYYYNevyVHVpEg-T7Xk462pz4/' target="_blank" class="btn btn-primary">Citește mai multe!</a>
          </div>
        </div>
        
        <div class="card mb-2 mt-4">
          <img src="assets/Fotografii/jurnal_trinitas_sfintirea_paraclisului.png" class="card-img-top" alt="Foto credit: Jurnal Trinitas">
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">Paraclisul de la demisolul bisericii Parohiei Pantelimon 2 a fost binecuvântat</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">Paraclisul biserii Parohiei Pantelimon 2 a fost binecuvântat</p>
            <a href='https://www.youtube.com/watch?v=DX2k8tN-Shw&ab_channel=TRINITASTV' target="_blank" class="btn btn-primary">Vizionează articolul!</a>
          </div>
        </div>
        <!--div class="card my-2">
          
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">Proiect și șantier noua biserică parohială</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">Proiect și șantier noua biserică parohială</p>
          </div>

          <img src="assets/Fotografii/constructie/{{proiectPhotos[currentProiectPhotoIndex]}}.jpg" class="card-img-top" alt="Parohia Pantelimon II">
        </div-->
        <div class="card mb-2 mt-4">
          <img src="assets/Fotografii/jurnal_trinitas_eveniment_caritabil.png" class="card-img-top" alt="Foto credit: Jurnal Trinitas">
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">Evenimentul caritabil „Tradiții și credință!” - Articol Jurnal Trinitas</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">Evenimentul caritabil „Tradiții și credință!”</p>
            <a href='https://www.youtube.com/watch?v=hptQGlwLYCY&t=7s&ab_channel=TRINITASTV' target="_blank" class="btn btn-primary">Vizionează articolul!</a>
          </div>
        </div>
        <div class="card mb-2 mt-4">
          <img src="assets/Fotografii/constructie/santier1.jpg" class="card-img-top" alt="Foto credit: Basilica">
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">„Din gunoi înalți pe cel lipsit!” - Articol Ziarul Lumina</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">„Din gunoi înalți pe cel lipsit!”</p>
            <a href='https://ziarullumina.ro/societate/reportaj/din-gunoi-inalti-pe-cel-lipsit-169032.html' target="_blank" class="btn btn-primary">Citește mai multe!</a>
          </div>
        </div>

        <div class="card my-2">
          <img src="assets/Fotografii/facebook/noutati_1.jpg" class="card-img-top" alt="Foto credit: Facebook / Parohia Pantelimon II">
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">PS Timotei a sfințit piatra de temelie a noii biserici din Pantelimon</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">PS Timotei a sfințit piatra de temelie a noii biserici din Pantelimon</p>
            <a href='https://basilica.ro/orasul-pantelimon-va-avea-o-noua-biserica-ps-timotei-prahoveanul-a-sfintit-piatra-de-temelie/' target="_blank" class="btn btn-primary">Citește mai multe!</a>
          </div>
        </div>
        <div class="card my-2">
          <img src="assets/Fotografii/facebook/noutati_2.jpg" class="card-img-top" alt="Foto credit: Protopopiatul Ilfov Sud">
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">100 de copii au participat la Tabăra „Credință prin joc”</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">100 de copii au participat la Tabăra „Credință prin joc”</p>
            <a href='https://basilica.ro/12-zile-de-credinta-prin-joc-pentru-tinerii-din-protopopiatul-ilfov-sud/' target="_blank" class="btn btn-primary">Citește mai multe!</a>
          </div>
        </div>
        <div class="card my-2">
          <img src="assets/Fotografii/facebook/noutati_3.jpg" class="card-img-top" alt="Foto credit: Protopopiatul Ilfov Sud">
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">Conferința clericilor din Protopopiatul Ilfov Sud</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">Conferința clericilor din Protopopiatul Ilfov Sud</p>
            <a href='https://basilica.ro/provocari-si-perspective-satul-romanesc-a-fost-evocat-in-conferinta-preotilor-din-ilfov-sud/' target="_blank" class="btn btn-primary">Citește mai multe!</a>
          </div>
        </div>
        
        <div class="card my-2">
          <img src="assets/Fotografii/Trinitas-comemorarea_1918.png" class="card-img-top" alt="Foto credit: Trinitas TV">
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">Comemorarea eroilor din Pantelimon</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">Comemorarea eroilor din Pantelimon</p>
            <a href='https://www.trinitas.tv/comemorarea-eroilor-din-pantelimon-care-au-luptat-primul-razboi-mondial/' target="_blank" class="btn btn-primary">Citește mai multe!</a>
          </div>
        </div>
        <div class="card my-2">
          <img src="assets/Fotografii/Conferinta-despre-Marea-Unire-in-Protopopiatul-Ilfov-Sud-2.jpg" class="card-img-top" alt="Foto credit: Basilica">
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">Contribuția Bisericii la conștiința identității și unității neamului românesc</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">Contribuția Bisericii la conștiința identității și unității neamului românesc</p>
            <a href='https://basilica.ro/biserica-si-marea-unire-clericii-din-protopopiatul-ilfov-sud-au-evidentiat-contributia-bisericii-la-infaptuirea-unirii-din-1918/' target="_blank" class="btn btn-primary">Citește mai multe!</a>
          </div>
        </div>
           
        <!--div class="card my-2">
          <img src="assets/Fotografii/facebook/noutati_4.jpg" class="card-img-top" alt="Foto credit: Protopopiatul Ilfov Sud">
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">Au fost sfințite două capele în județul Ilfov</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">Au fost sfințite două capele în județul Ilfov</p>
            <a href='hhttps://ziarullumina.ro/galerie/doua-capele-binecuvantate-in-judetul-ilfov-58453.html' target="_blank" class="btn btn-primary">Citește mai multe!</a>
          </div>
        </div-->
        <div class="card my-2">
          <img src="assets/Fotografii/facebook/noutati_4.jpg" class="card-img-top" alt="Foto credit: Protopopiatul Ilfov Sud">
          <div class="card-body">
            <h5 class="card-title d-none d-sm-block">A fost sfințită capela Parohiei Pantelimon II</h5>
            <p class="card-title d-block d-sm-none font-size-smaller font-weight-bold">A fost sfințită capela Parohiei Pantelimon II</p>
            <a href='https://basilica.ro/sfintirea-capelei-parohiei-pantelimon-ii-prot-ilfov-sud/' target="_blank" class="btn btn-primary">Citește mai multe!</a>
          </div>
        </div>      
        
        
      </div>
      <div class="col-12 col-md-2">   
        <div class="col my-2">  
          <a href='https://basilica.ro/' target="_blank" class="">   
            <img src="assets/IMG/Basilica.png" class="img-thumbnail half-width" alt="Foto credit: Agenția de știri Basilica.ro">
          </a>
        </div>
        <div class="col my-2">   
          <a href='https://www.trinitas.ro/' target="_blank" class="">    
          <img src="assets/IMG/Trinitas.png" class="img-thumbnail half-width" alt="Foto credit: Patriarhia Română - Trinitas TV">
        </a>
        </div>
        <div class="col my-2">  
          <a href='https://ziarullumina.ro/' target="_blank" class="">     
            <img src="assets/IMG/Lumina_1.png" class="img-thumbnail half-width" alt="Foto credit: Facebook Ziarul Lumina">
        </a>
        </div>
        <div class="col my-2">    
          <a href='https://doxologia.ro/' target="_blank" class="">   
            <img src="assets/IMG/Doxologia.png" class="img-thumbnail half-width" alt="Foto credit: Doxologia.ro - portal ortodox">
          </a>
        </div>
        <div class="col my-2">    
          <a href='https://www.stavropoleos.ro/' target="_blank" class="">   
            <img src="assets/IMG/Stavropoleos.png" class="img-thumbnail half-width" alt="Mănăstirea Stavopoleos">
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="chapter=='galeriefoto'">
  <div class="container-fluid">
    <div class="row justify-content-center align-items-center mt-3">
      <h3 class="fw-light">Din viața comunității</h3>
      <!--div class="col-3 col-sm-2 p-0 text-center h3"></div-->
      <div class="col-12 p-0 text-center">    
        <span class="h3 pointer" (click)="galleryLeft2()">&#8592;</span> 
        <img src="assets/Fotografii/viata_comunitatii/{{currentPhoto2}}.jpg" class="img-thumbnail" alt="...">
        <span class="h3 pointer" (click)="galleryRight2()">&#8594;</span>
      </div>
      <!--div class="col-3 col-sm-2 p-0 text-center h3"></div-->
    </div>
    <div class="d-flex row justify-content-center mt-3">
      <div *ngFor="let no of [1,2,3,4,5,6,7,8,9,10,11,12];" class="d-flex justify-content-center col-12 col-sm-6 col-md-3 col-xl-2 p-3">      
        <img src="assets/Fotografii/viata_comunitatii/{{no}}.jpg" (click)="gallerySet2(no)" class="img-thumbnail"  alt="Foto credit: Ziarul Lumina">
      </div>
    </div>
  </div>
</div>
<div *ngIf="chapter=='istoric'">
  <div class="container-fluid">
    <div class="row justify-content-center align-items-center mt-3">
      <h3 class="fw-light">Istoricul Parohiei</h3>
      <div class="m-3 text-justify h5">
        <p>&emsp;Parohia Pantelimon II cu hramurile „Sfinții Împărați Constantin și Elena” și „Sfântul Cuvios Grigorie Decapolitul” este situată în județul Ilfov ( Strada Vișinilor, nr. 24, Oraș Pantelimon) în zona de nord-est a Capitalei, la periferia orașului Pantelimon, fiind mărginită în partea de nord de Parohia Dobroiești, în partea de est de Parohia Pantelimon III, în partea de sud de Parohia „Sfântul Nicolae”-Pantelimon Sat, iar în partea de vest de Lacul Pantelimon. Odată cu dezvoltarea economică generală de după anul 2010, orașul Pantelimon din apropierea cetății Bucureștilor a cunoscut o reală evoluție, fiind construite multe locuințe. Inițial, actuala localitate Pantelimon s-a numit „Obilești”, iar mai târziu „Florești”. După ce, în prima jumătate a secolului al XVIII-lea, domnitorul Țării Românești, Grigorie Ghica al II-lea (1735-1750), a construit o mănăstire și un spital pe o insulă din lacul aflat în vecinătate, locul a început să fie numit „Pantelimon”. Ca semn al milei lui Dumnezeu față de acest loc, în data de 23 septembrie 1750, domnitorul Grigorie a reușit să dăruiască mănăstirii o parte însemnată din cinstitele moaște ale Sfântului Mare Mucenic Pantelimon (brațul drept), pe care le-a adus din Grecia. O parte din vechiul sat a fost inclusă în municipiul București, iar restul, devenit oraș în anul 2005, a continuat să se extindă către nord, unde oamenii cultivau livezi (de unde și numele stăzilor: Viilor, Vișinilor, Cireșilor, Caișilor etc.) zonă în care a luat ființă și Parohia Pantelimon II. Orașul este integrat din punct de vedere economic în București, în Pantelimon funcționând însă și unele firme, active mai ales în industria alimentară. Este traversat de două axe principale de transport rutier, DN 3 și centura Bucureștiului, dar și de calea ferată București-Constanța. Dintre orașele județului Ilfov, Pantelimonul este cel mai întins ca suprafață și al doilea ca populație, după Voluntari.</p>

        <br>
        <p>&emsp;Parohia a fost înființată prin Hotărârea Permanenței Consiliului Eparhial al Arhiepiscopiei Bucureștilor în ședința sa din data de 5 aprilie 2011, în localitatea Pantelimon, prin desprinderea unui sector pastoral din cadrul Parohiei ,,Sfântul Nicolae”-Pantelimon Sat. Ulterior, prin decizia nr. 90/2011, dată în Reședința Patriarhală din București la data de 20 mai 2011, Preafericitul Părinte Patriarh Daniel l-a numit în funcția de preot paroh la Parohia Pantelimon II pe Paraschivoiu Iulian. La data de 3 decembrie 2011, o comisie a Centrului Eparhial, împreună cu Preacucernicul Părinte Protoiereu Romică Macovei, a procedat la arondarea parohiei. Cu binecuvântarea Preafericitului Părinte Patriarh Daniel și cu bunăvoința domnului Marian Ivan, primarul orașului Pantelimon, și a membrilor Consiliului Local, a fost oferit un teren în suprafață de 1119 mp, situat pe strada Vișinilor, la numărul 24, cu destinația construirii unei biserici parohiale. Pe data de 16 iunie 2016, a fost sfințit paraclisul din lemn cu hramurile „Sfinții Împărați Constantin și Elena” și „Sfântul Cuvios Grigorie Decapolitul”, de către Preasfințitul Părinte Timotei Prahoveanul, Episcopul-vicar al Arhiepiscopiei Bucureștilor. Până la momentul respectiv, locuitorii zonei beneficiau de serviciile religioase ale bisericii Parohiei „Sfântul Nicolae”-Pantelimon Sat.</p>
      
        <br>
        <p>&emsp;În data de 20 iunie 2016, a fost numit ca preot coslujitor Daniel Novac, numit ca preot paroh în data de 1 octombrie 2017. În anul 2018, a fost extins paraclisul din lemn prin adăugarea unui pridvor și a unui altar, au fost construite 3 grupuri sanitare, o capelă mortuară și o sală de mese. În anul 2020, acestora li s-a adăugat un altar de vară. În decembrie 2018, în urma vacantării postului II de preot, a fost numit preot coslujitor George Florentin Sandu. Pe data de 17 noiembrie 2019, a fost sfințit locul pentru noua biserică parohială cu hramurile „Sfinții Împărați Constantin și Elena” și „Sfântul Cuvios Grigorie Decapolitul”, paroh fiind preotul Daniel Novac. În august 2020 a fost obținută autorizația de construire a unei biserici parohiale din zid (nr. 258/18.08.2020), pe baza proiectului arhitectonic întocmit de Șerban Popa și a proiectului de rezistență întocmit de inginerul Mădălin Voica. Lucrările efective de construcție a bisericii au început pe 12 iulie 2021. În momentul de față se execută lucrări de infrastructură până la cota +_0,00 a bisericii.</p>
      
        <br>
        <p>&emsp;Biserica va fi edificată pe un plan cruciform, înscris într-un dreptunghi cu laturile de 16+17 m, cu demisol pe toată suprafața construibilă. Construcția va fi executată din beton armat, placată cu cărămidă atât la interior, cât și la exterior. Stilul arhitectonic predominant este cel propriu bisericilor românești. În momentul de față, se dorește finalizarea lucrărilor de rezistență până la cota +_0,00.</p>
      
        <br>
        <p>&emsp;Șirul preoţilor slujitori: Iulian Paraschivoiu (2011-1018), Daniel Novac (din 2016, actualul paroh), George Florentin Sandu (din 2018). Cântăreți: Bîrcă Marius Cristian, Stanciu Teodor Costel (actualmente Pr. Diac. Teodor Constantin Stanciu de la Parohia Chitila), Negruț Ioan. Epitrop: Surdu Stelian.</p>
      
        <br>
        <p>&emsp;Pe lângă programul liturgic și administrativ, Parohia Pantelimon II încearcă să inițieze o serie de noi programe de natură pastoral-misionară, culturală și filantropică. În fiecare săptămână se desfășoară câte o cateheză. În fiecare duminică și în sărbători, li se oferă, în regim de cantină, câte o masă caldă celor nevoiași. În cele patru mari posturi de peste ani se organizează colecte de haine și alimente, pe care delegații parohiei le distribuie persoanelor aflate în lipsă, din diverse zone ale țării.</p>
      </div>
      <!--div class="col-3 col-sm-2 p-0 text-center h3"></div-->
    </div>
  </div>
</div>
<div *ngIf="chapter=='preoti'">
  <div class="align-items-center mt-3">
    <h3 class="fw-light text-center">Preoți slujitori</h3>
  </div>
  <div class="container-fluid">
    <div class="row justify-content-around">
      <div class="col-12 col-md-6 align-items-center mt-3">
        <div class="card my-2">
          <div class="card-body">
            <h4>Preot paroh:</h4> 
            <h5>Preot Novac Dănuț</h5>
            <br>
            <img width="150px" src="assets/Fotografii/preoti/Pr_Novac.jpg"/>
            <br><br>
            <p><b>Nr. contact:</b></p> 
            <p>0763.666.435</p>
            <p><b>E-mail:</b></p> 
            <p>novakdanut@yahoo.com</p>
          </div>
        </div>
      </div> 
      <div class="col-12 col-md-6 align-items-center mt-3">    
        <div class="card my-2">
          <div class="card-body">
            <h4>Preot slujitor:</h4> 
            <h5>Preot Sandu George-Florentin</h5>
            <br>
            <img width="150px" src="assets/Fotografii/preoti/Pr_Sandu.jpg"/>
            <br><br>
            <p><b>Nr. contact:</b></p> 
            <p>0720.747.470</p>
            <p><b>E-mail:</b></p> 
            <p>viasandu@yahoo.com</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="chapter=='2lasuta'">
  <div class="row justify-content-center">   
    <div class="align-items-center text-center">
      <h3>Donează 2% pentru Biserică!</h3>
      <br><br>
      <a href="./assets/Formular/Formular_anaf_pt_anul_2025.pdf" target="_blank" class="btn btn-primary">Descarcă formularul!</a>
      <br><br>
    </div> 
  </div>

  <pdf-viewer [src]="pdfSrc" 
              [render-text]="true"
              style="display: block;"
              fit-to-page="true"
  ></pdf-viewer>
</div>
<div class="p-3">
  <a target="_blank" class="font-size-bigger pointer" href="https://www.protoieriailfovsud.ro/church/parohia-pantelimon-ii/">Salt la pagina web a Protoieriei Ilfov Sud, secțiunea dedicată Parohiei Pantelimon II.</a>
  <br>
  <span class="font-size-bigger">Parohia Pantelimon II, anul 2025. </span>
  <a class="font-size-bigger pointer" (click)="despreSite()">Despre site.</a>
</div>


